import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';

import GeneralReport from './GeneralReport';

const GeneralReportContainer = props => (
  <Provider store={store}>
    <GeneralReport {...props} />
  </Provider>
);

export default GeneralReportContainer;
